var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { class: { 'is-transparent': _vm.emptyTransparency, 'empty-view-wrap': true } }, [_c('svg-icon', { staticClass: "noresultsearch", attrs: { "iconClass": "no_result_search" } }), _vm._v(" "), [_c('div', { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm.showMsg ? _c('div', { staticClass: "msg", domProps: { "innerHTML": _vm._s(_vm.msg) } }) : _vm._e()], _vm._v(" "), _vm._t("default")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };